import { FC, ReactNode } from 'react';

import { Box, Container, ContainerProps, rem } from '@bonusly/design-system';

export const PAGE_MAX_WIDTH = rem(1024);

export interface ContentContainerProps extends ContainerProps {
	bgColor?: string;
	children: ReactNode;
}

export const ContentContainer: FC<ContentContainerProps> = ({ bgColor, children, ...props }) => {
	return (
		<Box p={{ base: rem(16), sm: rem(48) }} bg={bgColor}>
			<Container maxW={PAGE_MAX_WIDTH} minH="100%" mx="auto" p={0} {...props}>
				{children}
			</Container>
		</Box>
	);
};
